import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskItsmTicketTypeFieldsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'project-settings-servicedesk-itsm-ticket-type-fields',
	path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?',
};
